import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import image_google from "../../../assets/img/images.png";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const YOUTUBE_URL = process.env.REACT_APP_YOUTUBE_URL;
const GOOGLE_URL = process.env.REACT_APP_GOOGLE_URL;

function Youtube() {
  const { section, id } = useParams();
  const [servicesData, setServicesData] = useState([]);
  const [pageYoutube, setPageYoutube] = useState(1);
  const [youtubePagination, setYoutubePagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 3,
    total: 0,
  });

  useEffect(() => {
  if ((section !== "Home") && (section !== undefined)) {
    const randomStartPage =
      Math.floor(Math.random() * 5) + 1;

    setPageYoutube(randomStartPage);
  }
}, [section]);


  const changePage = (page) => {
    if (
      youtubePagination &&
      page >= 1 &&
      page <= youtubePagination.last_page
    ) {
      const scrollPosition = window.scrollY;

      setPageYoutube(page);

      setTimeout(() => {
        window.scrollTo({
          top: scrollPosition,
          behavior: "instant",
        });
      }, 50);
    }
  };

  
  useEffect(() => {
    fetchYoutubeData();
  }, [section, id, pageYoutube]);

  async function fetchYoutubeData() {
    try {
      await axios.get("sanctum/csrf-cookie");

      const response = await axios.get(
        `${BASE_URL}posdata?columes[eq]=title_advert_utube&ministry[eq]=1&status02[eq]=publish&status[eq]=Public&visibility[eq]=Public&page=${pageYoutube}&per_page=3`,
      );

      if (response.data.status === 200) {
        setServicesData(response?.data?.allData || []);
        setYoutubePagination(response?.data?.pagination || {});
      }
    } catch (error) {
      console.log("Error", error);
    }
  }

  if (servicesData.length === 0) {
    return null;
  }

  return (
    <section id="services" className="services section">
      <div className="container section-title" data-aos="fade-up">
        <h2>MEDIA SPORTLIGHT</h2>

        <p>
          <span>Bringing Policies </span>
          <span className="description-title">to Life</span>
        </p>
      </div>

      <div className="container">
        <div className="row gy-4">
          {servicesData.map((service, index) => {
            const addressLink =
              service.addressLink.split("*Locat*");

            return (
              <div
                className="col-lg-4 col-md-6"
                data-aos="fade-up"
                data-aos-delay={100 + index * 100}
                key={service.id || index}
              >
                <div className="card h-100 shadow border-0">
                  <Link
                    to={
                      addressLink[1] === "youtube"
                        ? `${YOUTUBE_URL}${addressLink[0]}`
                        : `${GOOGLE_URL}${addressLink[0]}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="position-relative mb-2">
                      <iframe
                        width="100%"
                        height="300"
                        src={
                          addressLink[1] === "youtube"
                            ? `${YOUTUBE_URL}${addressLink[0]}`
                            : image_google
                        }
                        title={service.title}
                        loading="lazy"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>

        {/* Pagination */}
        <div className="d-flex justify-content-end align-items-center mt-3">
          <button
            className="btn btn-dark me-2"
            onClick={() => changePage(1)}
            disabled={youtubePagination.current_page === 1}
          >
            «
          </button>

          <button
            className="btn btn-dark me-2"
            onClick={() =>
              changePage(youtubePagination.current_page - 1)
            }
            disabled={youtubePagination.current_page === 1}
          >
            ‹
          </button>

          <span className="me-2">
            Page {youtubePagination.current_page} of{" "}
            {youtubePagination.last_page}
          </span>

          <button
            className="btn btn-dark me-2"
            onClick={() =>
              changePage(youtubePagination.current_page + 1)
            }
            disabled={
              youtubePagination.current_page ===
              youtubePagination.last_page
            }
          >
            ›
          </button>

          <button
            className="btn btn-dark"
            onClick={() =>
              changePage(youtubePagination.last_page)
            }
            disabled={
              youtubePagination.current_page ===
              youtubePagination.last_page
            }
          >
            »
          </button>
        </div>
      </div>
    </section>
  );
}

export default React.memo(Youtube);